/**
*
*   Shopify Store
*       - Loads the Store Data
*
**/
const obj = {

	//Load all pages
	all: {
		type: 'query',
		request: `
			pages(first: 250) {
				edges {
					node {
						title
						handle
						updatedAt
					}
				}
			}

		`
	},


	//Load a specific page
	load: {
		type: 'query',
		variables: '$handle: String!',
		request: `
			pageByHandle(handle: $handle){
				body
				bodySummary
				createdAt
				id
				title
				trackingParameters
				seo {
					title
					description
				}
			}
		`
	}
};

//Export
export default obj;